import { Box, Grid, MenuItem, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../component/table/tableCustom';
import { icons } from '../../../constants/images';
import TableRowCommon from '../../../component/table/TableRowCommon';
import FilterSelect from '../../../component/select/filterSelect';
import { LayoutTitle, LayoutView, TitleText } from '../../../component/layout/layoutMainStyle';
import InputDatePicker from '../../../component/input/inputDatePicker';
import moment from 'moment';
import ButtonCustom from '../../../component/button/buttonCustom';
import { useSelector } from 'react-redux';
import AutocompleteSelect from '../../../component/select/autoCompleteSelect';
import LogApi from '../../../api/statistics/statistics.api';
import saveAs from 'file-saver';
import DepartmentApi from '../../../api/departments/departments.api';
import RoleApi from '../../../api/role/role.api';

export default function StatisticsUsage() {
    const { profile } = useSelector((state: any) => state.profile)
    const permit = profile?.permission || []
    const [sortBy, setSortBy] = useState<string>('')
    const [sortType, setSortType] = useState<string>('ASC')
    const [open, setOpen] = useState<boolean>(false)
    const [data, setData] = useState<any>([])
    const [page, setPage] = useState<number>(1);
    const [refCode, setRefCode] = useState<string>('');
    const [refCodeData, setRefCodeData] = useState<any>([]);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [rowCount, setRowCount] = useState<number>(3);
    const [totalPages, setTotalPages] = useState<number>(3);
    const [totalItem, setTotalItem] = useState<number>(60);
    const [sdate, setSdate] = useState<string>('');
    const [edate, setEdate] = useState<string>('');
    const [idDepartment, setIdDepartment] = useState<any>();
    const [idRole, setIdRole] = useState<any>();
    const [departments, setDepartments] = useState<any>([]);
    const [roles, setRoles] = useState<any>([]);
    const onRequestSort = (sortBy: string, sortType: string) => {
        setSortType(sortType)
        setSortBy(sortBy)
    }
    const loadData = useCallback(async () => {
        let condition: any = {};
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment.idDepartment };
        if (idRole) condition = { ...condition, idRole: idRole.idRole };
        if (sdate) condition = { ...condition, startDate: sdate };
        if (edate) condition = { ...condition, endDate: edate };
        if (sortBy) condition = { ...condition, sortBy: sortBy };
        if (sortType) condition = { ...condition, sortType: sortType };
        if (page) condition = { ...condition, page: page };
        if (pageLimit) condition = { ...condition, limit: pageLimit };
        LogApi.getRequestLog(condition).then((res) => {
            if (res?.data?.success) {
                const { items, meta } = res.data.result;
                setData(items);
                setPage(meta.currentPage)
                setRowCount(meta.totalItems)
                setTotalItem(meta.totalItems)
                setTotalPages(meta.totalPages)
            }
        });
    }, [idDepartment, idRole, sdate, edate, sortBy, sortType, page, pageLimit]);

    useEffect(() => {
        loadData()
    }, [loadData])
    const getRoles = async () => {
        RoleApi.getRoles({}).then((res) => {
            if (res?.data?.success) {
                const { items } = res.data.result;
                setRoles(items);
            }
        })
    }


    const getDepartments = async () => {
        const res = await DepartmentApi.getDepartments({})
        const data = res.data
        if (data.success) {
            setDepartments(data.result.items)
        }
    }

    useEffect(() => {
        getRoles()
        getDepartments()
    }, [])
    const download = async () => {
        let condition: any = {};
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment.idDepartment };
        if (idRole) condition = { ...condition, idRole: idRole.idRole };
        if (sdate) condition = { ...condition, startDate: sdate };
        if (edate) condition = { ...condition, endDate: edate };
        LogApi.getRequestLogDownload(condition).then((res) => {
            const data = res.data;
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'สถิติการใช้งาน');
        }
        );
    }
    const headCells = [
        {
            id: "no",
            label: 'ลำดับ',
            align: "left",
            colSpan: 1,
            sortable: true
        },
        {
            id: "createDate",
            label: 'วันที่',
            align: "left",
            colSpan: 1,
            sortable: true
        },
        {
            id: "ip",
            label: 'IP Address',
            align: "left",
            colSpan: 1,
        },
        {
            id: "departmentName",
            label: 'หน่วยงาน',
            align: "left",
            colSpan: 1,
            sortable: true,
        },
        {
            id: "url",
            label: 'กิจกรรมที่ใช้งาน',
            align: "left",
            colSpan: 1,
            sortable: true,
        },
        {
            id: "employeeName",
            label: 'ผู้ใช้งาน',
            align: "left",
            colSpan: 1,
        },
        {
            id: "roleName",
            label: 'บทบาท',
            align: "left",
            colSpan: 1,
        },
        
    ];


    const renderData = (objData: any, index: any) => {
        const { createDate, ip, roleName, departmentName, employeeName, idLogDocument, url } = objData;
        index = page * pageLimit - pageLimit + index + 1;

        const objRenderData = {
            key: index,
            id: idLogDocument,
            obj: objData,
            columns: [
                { option: "TEXT", align: "left", label: index },
                { option: "TEXT", align: "left", label: new Date(createDate).toLocaleString('Th-th', { dateStyle: 'long', timeStyle: 'medium' }) },
                { option: "TEXT", align: "left", label: ip },
                { option: "TEXT", align: "left", label: url },
                { option: "TEXT", align: "left", label: departmentName },
                { option: "TEXT", align: "left", label: employeeName },
                { option: "TEXT", align: "left", label: roleName },
               

            ],

        }


        return (
            <TableRowCommon
                {...objRenderData}
                ondocumentdetail={() => { }}
            />
        )
    };
    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>สถิติการใช้งาน</TitleText>
            </LayoutTitle>
            <Grid container columns={15} sx={{ marginBottom: '12px' }}>
                <Grid md={2} xs={15} sx={{ marginRight: { md: '10px', xs: '0px' }, marginBottom: { md: '0px', xs: '8px' } }}>
                    <InputDatePicker
                        dateFormat="DD/MM/YYYY"
                        required={false}
                        key={""}
                        disabled={false}
                        label=""
                        value={sdate}
                        onClear={() => setSdate('')}
                        onChange={(e: any) => setSdate(moment(e).format("YYYY-MM-DD"))
                        }
                        allowClear
                        heading={'ตั้งแต่วันที่'} />
                </Grid>
                <Grid md={2} xs={15} sx={{ marginRight: { md: '10px', xs: '0px' }, marginBottom: { md: '0px', xs: '8px' } }}>
                    <InputDatePicker
                        dateFormat="DD/MM/YYYY"
                        required={false}
                        key={""}
                        disabled={false}
                        label=""
                        value={edate}
                        onClear={() => setEdate('')}
                        onChange={(e: any) => setEdate(moment(e).format("YYYY-MM-DD"))
                        }
                        allowClear
                        heading={'ถึงวันที่'} />
                </Grid>
                <Grid md={2} xs={15} sx={{ marginRight: { md: '10px', xs: '0px' }, marginBottom: { md: '0px', xs: '8px' } }}>

                    <AutocompleteSelect
                        options={departments}
                        // disabled={location.state.params.isView}
                        getOptionLabel={(option: any) => option?.departmentName}
                        labelId="addmin-type"
                        value={idDepartment}
                        heading={'หน่วยงานทั้งหมด'}
                        placeholder='ทั้งหมด'
                        onChange={(event, newValue) => {
                            setIdDepartment(newValue)
                        }}
                        // required
                        helperText={''}
                    />
                </Grid>
                <Grid md={2} xs={15} sx={{ marginRight: { md: '10px', xs: '0px' }, marginBottom: { md: '0px', xs: '8px' } }}>

                    <AutocompleteSelect
                        options={roles}
                        // disabled={location.state.params.isView}
                        getOptionLabel={(option: any) => option?.roleName}
                        labelId="addmin-type"
                        value={idRole}
                        heading={'ประเภทสมาชิก'}
                        placeholder='ทั้งหมด'
                        onChange={(event, newValue) => {
                            setIdRole(newValue)
                        }}
                        // required
                        helperText={''}
                    />
                </Grid>
                <Grid md={2} xs={15} sx={{ marginRight: { md: '10px', xs: '0px' }, marginBottom: { md: '0px', xs: '8px' } }}>
                </Grid>
                <Grid md={2.5} xs={15} sx={{ marginRight: { md: '10px', xs: '0px' }, marginBottom: { md: '0px', xs: '8px' } }}>
                </Grid>
                <Grid md={1.5} xs={15}>
                    {
                        permit.find((x: any) => x?.code === 'Statistics.Download.Export')?.permit &&
                        <div>
                            <Typography sx={{ marginBottom: '8px' }}>ส่งออกเอกสาร</Typography>
                            <ButtonCustom variant={'outlined'}
                                endIcon={<icons.downloadButton />}
                                textButton={'Excel'}
                                onClick={() => { download() }}

                                btnStyle={{
                                    '&.MuiButton-outlined': {
                                        width: '100%',
                                        color: `#323539 !important`,
                                        padding: '8px',
                                        border: `1px solid #E5E5E7 !important`,
                                        borderRadius: "10px !important",
                                        '&:hover': {
                                            padding: '8px',
                                            color: `#323539  !important`,
                                            border: `1px solid #E5E5E7 !important`,
                                            backgroundColor: '#EFFFF7 !important'
                                        },
                                    },
                                }} />
                        </div>
                    }

                </Grid>

            </Grid>
            <TableCustom
                headCells={headCells}
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortType={sortType}
                sortBy={sortBy}
                rowCount={rowCount}
                rowsData={data?.map((d: any, index: any) => {
                    return renderData(d, index);
                })}
                onSort={onRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
                totalPages={totalPages}
                totalItem={totalItem}
            />
        </LayoutView>
    )
}
